import { BlankStateIcon } from '@/assets/icons';

export const BlankState = ({ message = 'No results found.' }: { message?: string }) => {
  return (
    <div className="flex flex-col items-center justify-center bg-transparent overflow-y-auto h-[55vh] gap-6">
      <BlankStateIcon className="flex-shrink-0" />
      <span className="font-medium text-body-sm text-neutral-7">{message}</span>
    </div>
  );
};
